<template>
  <div>
    <q-btn
      v-if="$_.isObject(value) && value.handleClick"
      flat
      :icon="value.name"
      :color="value.color"
      size="md"
      dense
      :loading="loading"
      :clickable="!!value.handleClick"
      @click="handleClick"
    >
      <q-tooltip v-if="value.tooltip">
        {{ value.tooltip }}
      </q-tooltip>
    </q-btn>
    <q-icon
      v-else-if="$_.isObject(value)"
      :name="value.name"
      :color="value.color"
      size="md"
    >
      <q-tooltip v-if="value.tooltip">
        {{ value.tooltip }}
      </q-tooltip>
    </q-icon>
    <q-icon
      v-else
      class="text-grey-8"
      :icon="value"
      size="md"
    />
  </div>
</template>

<script>

export default {
  name: 'IconCell',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async handleClick (event) {
      this.loading = true
      if (!this.value.handleClick) {
        return
      }
      event.stopPropagation()
      await this.value.handleClick()
      this.loading = false
    }
  }
}
</script>
